
import { motion } from "framer-motion";

export const HebrewProcessSteps = () => {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold mb-4 text-blue-800">תהליך בקשת ההלוואה בפינלנד</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">1</div>
          <h3 className="text-lg font-medium mb-2">השלם בקשה</h3>
          <p className="text-gray-600">מלא בקשה אחת להשוואת הצעות הלוואה מרובות.</p>
        </div>
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">2</div>
          <h3 className="text-lg font-medium mb-2">קבל הצעות</h3>
          <p className="text-gray-600">הבנקים בוחנים את בקשתך ומספקים הצעות הלוואה תוך 24 שעות.</p>
        </div>
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">3</div>
          <h3 className="text-lg font-medium mb-2">קבל את ההצעה הטובה ביותר</h3>
          <p className="text-gray-600">השווה תנאים וקבל את ההצעה שהכי מתאימה לצרכים שלך.</p>
        </div>
      </div>
    </div>
  );
};
